/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 */
import { useEffect, useState } from 'react';
import { useAuth } from '@/lib/auth';
import { useOnboardingStatus } from '@/lib/onboardingStatus';

const readFlag = (key) => {
  try { return sessionStorage.getItem(key) === '1'; } catch { return false; }
};
const writeFlag = (key) => {
  try { sessionStorage.setItem(key, '1'); } catch { /* noop */ }
};

/**
 * Shared visibility logic for the onboarding pill + banner.
 * Returns `{ visible, status, dismiss }`; consumes the shared
 * OnboardingStatusContext so no extra HTTP call is made.
 */
export const useOnboardingCta = (storageKey, { hideWhen = false } = {}) => {
  const { user } = useAuth();
  const { status } = useOnboardingStatus();
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => { setDismissed(readFlag(storageKey)); }, [storageKey]);

  const isPatient = user?.role === 'patient' || user?.category === 'paziente';
  const visible = Boolean(user && !isPatient && status?.next_step && !dismissed && !hideWhen);

  const dismiss = () => {
    writeFlag(storageKey);
    setDismissed(true);
  };

  return { visible, status, dismiss };
};
